export default async function ({ store, app }) {
  const cookieRes = app.$cookiz.get('__MOTIONROUTES_REFERRAL_ID');
  if (cookieRes && Object.keys(cookieRes).length > 0) {
    store.commit('global/SET_DISCOUNT', +cookieRes.cp);
  }
}
